import { AppHelper } from "../appHelper"
import { AppBaseProps, CommonApp, Context, Entity } from "../core/components/commonApp";
import { MetaDataHelper } from "../core/util/metaDataHelper";
import { NotificationHelper } from "../core/util/notificationHelper";
import { HTTPService } from "../core/util/httpManager";
import { ComponentHelper } from "../core/util/componentHelper";
import { TextBox } from "../core/components/textBox";
import { StringKeyDictionary } from "../commonInterfaces";
import NewPasswordTextBox, {  NewPasswordTextBoxField, NewPasswordTextBoxProps } from "../userSettings/newPasswordTextBox";
import React from "react";
export default class ChangePasswordApp extends React.Component<ChangePasswordAppProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string> = null;
    maxLenght: number = 32;
    private factory = ComponentHelper.createFactory();
    constructor(props: ChangePasswordAppProps) {
        super(props);
        //this.maxLenght = props.extendedLoginActive ? 32 : 8;
        this.common.enableHooks = true;
        this.common.init(this);
    }
   
    save = (closeAfterSave) => {
        if (this.common.validate()) {
            HTTPService.post("Account/ChangePassword", this.props.entity)
                .then((result) => {

                    MetaDataHelper.setFieldValue(this.props.entity, "entity.NewPassword", null);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.NewPasswordReplay", null);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.OldPassword", null);

                    if (result.Code === 0) {
                        NotificationHelper.showSuccessMessage(result.Message);
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }

                    this.common.handlePostSave(result.Code === 0, closeAfterSave);

                    if (result.Code == 0) {
                        setTimeout(() => {
                            document.getElementById('logout-form__trigger').click();
                        }, 1000);
                    }
                });
        }
    }
    renderNewPasswordTextBox = (model) => {
        const textBoxProps = this.factory.getDefaultTextBoxProps();
        const field: NewPasswordTextBoxField = {
            ...textBoxProps.field,
            useExtendedLogin: this.props.extendedLoginActive
        }
        const props: NewPasswordTextBoxProps = {
            ...textBoxProps,
            field
        }
        props.value = MetaDataHelper.getFieldValue(this.props.entity, model);
        props.field.isPassword = true;
        props.field.maxLength = this.maxLenght;
        props.field.required = true;
        props.onChange = (_, value) => {
            this.common.handleFieldChange({ model: model }, value);
        }
        return <NewPasswordTextBox {...props} />;
    }
    renderTextBox = (model: any) => {
        const props = this.factory.getDefaultTextBoxProps();
        props.value = MetaDataHelper.getFieldValue(this.props.entity, model);
        props.field.isPassword = true;
        props.field.maxLength = this.maxLenght;
        props.field.required = true;
        props.onChange = (_, value) => {
            this.common.handleFieldChange({ model: model }, value);
        }
        return <TextBox {...props} />;
    }
    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps());
        return <CommonApp {...props} />;
    }
}

export interface ChangePasswordAppProps extends AppBaseProps {
    entity: ChangePasswordEntity;
    context: ChangePasswordAppContext;
    extendedLoginActive: boolean;
}

interface ChangePasswordAppContext extends Context {
}



//change password
interface ChangePasswordEntity extends Entity {
    NewPassword: string;
    NewPasswordReplay: string;
    OldPassword: string;
}